module.exports = __webpack_public_path__ + "img/about-banner.4f39c3e5.png";